export default __webpack_public_path__ + "static/media/tv_station.36550568.svg";